export default {
  app: {
    version: process.env.REACT_APP_VERSION,
  },
  apiGateway: {
    customers: {
      URL: process.env.REACT_APP_CUSTOMERS_URL,
    },
  },
};



// WEBPACK FOOTER //
// ./src/config.js